var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagBelarus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1691_40904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95669 11.1305L3.65234 8.76408L4.95669 6.43481L6.26103 8.76408L4.95669 11.1305Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34829 11.1305L1.04395 8.76408L2.34829 6.43481L3.65263 8.76408L2.34829 11.1305Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95669 17.5653L3.65234 15.1989L4.95669 12.8696L6.26103 15.1989L4.95669 17.5653Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34829 17.5653L1.04395 15.1989L2.34829 12.8696L3.65263 15.1989L2.34829 17.5653Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26138 2.32936L5.8921 1.66992C5.22976 2.06236 4.60852 2.51672 4.03613 3.02503L4.95704 4.6957L6.26138 2.32936Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95702 19.3044L4.02637 20.9664C4.59824 21.4754 5.21905 21.9305 5.88112 22.3237L6.26141 21.6338L4.95702 19.3044Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30469 15.1304V23.0458C8.74698 23.6597 10.3338 23.9999 12.0003 23.9999C17.1599 23.9999 21.5584 20.7434 23.254 16.1738L7.30469 15.1304Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.254 16.1739C23.7363 14.8739 24.0003 13.4678 24.0003 12C24.0003 5.37263 18.6277 0 12.0003 0C10.334 0 8.74698 0.339984 7.30469 0.953813V16.1739H23.254V16.1739Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1691_40904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBelarus);
export default __webpack_public_path__ + "static/media/flag-belarus.d6cd7a844886fb14d4357823a5ac3d02.svg";
export { ForwardRef as ReactComponent };